<div style="width: 100%">
    <div class="gantt_container" (window:resize)="onResize($event)">
        <gantt-header [name]="_project.name" [startDate]="_project.startDate"></gantt-header>
        <gantt-activity [project]="_project" [options]="_options" (onGridRowClick)="gridRowClicked($event)"></gantt-activity>
        <!-- <gantt-footer [project]="_project"></gantt-footer> -->
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/gantt-chart/gantt/gantt.component.html